export default __webpack_public_path__ + "static/exec-banner-e8e3ff939c0b17c4f616d4e330fac920.png";